import { userAgent } from '@tink/tink-link-core/src/user-agent-detector';
import { useConfiguration } from '../components/ApplicationProviders/ConfigurationProvider/ConfigurationProvider';
import { navigateUserToInitialTinkLinkAfterThirdPartyRedirect } from '../models/configuration';
import { CredentialsEntity } from '../models/credentials';
import { isRedirectMode as isRedirectModeImport } from './tink-link';

type UseIsFlowHandledByRedirectHandlerProps = {
  redirectedCredentialsId: string;
  appUri: string | undefined;
  credentials?: CredentialsEntity;
  isRedirectMode?: boolean;
  isMobile?: boolean;
};

export const useIsFlowHandledByRedirectHandler = ({
  redirectedCredentialsId,
  appUri,
  credentials,
  isRedirectMode = isRedirectModeImport(),
  isMobile = userAgent.isMobile,
}: UseIsFlowHandledByRedirectHandlerProps) => {
  const { data: configuration } = useConfiguration();

  if (navigateUserToInitialTinkLinkAfterThirdPartyRedirect(configuration) && isMobile) {
    return false;
  }

  // Copying logic of `getCredentialsAppUri`
  return redirectedCredentialsId === credentials?.id && isRedirectMode && !appUri;
};
